<div class="modal-container billing-address-modal-container">
  <div class="modal-content">
    <div class="modal-header d-flex align-items-center">
      <h4 class="modal-title">{{ 'personalInfo.billingModalTitle' | cxTranslate }}</h4>
      <button class="btn btn-link p-0 my-auto border-0 ml-auto close" aria-label="Close" (click)="closeModal('Close')">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="main-wrapper" [ngClass]="{ 'no-state': this.count === 0 }">
        <app-dynamic-form
          (formGroupEmit)="updateFormGroup($event)"
          (formModelEmit)="updateFormModel($event)"
          [formGroupId]="'CHANGE_BILLING_ADDRESS'"
          [static]="false"
          [emitOnInit]="true"
        ></app-dynamic-form>
      </div>
    </div>
    <div class="modal-footer justify-content-sm-between justify-content-md-end">
      <button type="button" class="btn secondary-btn" (click)="closeModal('Close')">
        {{ 'common.cancel' | cxTranslate }}
      </button>
      <button
        (click)="onSubmit()"
        [disabled]="buttonNoUpdate || !this.formGroup?.valid"
        type="button"
        class="btn primary-btn desktop"
      >
        {{ 'personalInfo.requestChange' | cxTranslate }}
      </button>
    </div>
  </div>
</div>
